import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { forkJoin, Observable } from 'rxjs';
import { AuthDataStore } from '../auth-data/auth-data.store';
import { getAccount, getUser, initialState } from './account-data.reducer';
import { Account } from './account.model';
import { User } from './user.model';
import { filter, map, take } from 'rxjs/operators';

@Injectable()
export class AccountDataStore {
  account$: Observable<Account> = this._store
    .select(getAccount)
    .pipe(filter((account: Account) => account !== initialState.account));
  user$: Observable<User> = this._store
    .select(getUser)
    .pipe(filter((user: User) => user !== initialState.user));

  constructor(
    private _store: Store<any>,
    private _authDataStore: AuthDataStore
  ) {}

  getAccount(): Observable<Account> {
    return this.account$.pipe(take(1));
  }

  getUser(): Observable<User> {
    return this.user$.pipe(take(1));
  }

  isOwnerUser(): Observable<boolean> {
    return forkJoin(this.getAccount(), this._authDataStore.getAccountId()).pipe(
      map(
        ([account, accountId]) =>
          account &&
          account.ownerUserId &&
          account.ownerUserId.toString() === accountId
      ),
      take(1)
    );
  }
}
